import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext({ user: null, loading: true, login: async () => {}, register: async () => {}, logout: async () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchMe(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.mfa_required) return data; // caller must prompt for a TOTP code next
    setUser(data);
    return data;
  };

  const completeMfaLogin = async (mfaToken, code) => {
    const { data } = await api.post("/auth/login/2fa", { mfa_token: mfaToken, code });
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };

  const requestOtp = (identifier, purpose) =>
    api.post("/auth/otp/request", { identifier, channel: "whatsapp", purpose }).then(r => r.data);

  const verifyOtp = async (identifier, otp, purpose, name) => {
    const { data } = await api.post("/auth/otp/verify", { identifier, otp, purpose, name });
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, completeMfaLogin, register, requestOtp, verifyOtp, logout, refresh: fetchMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
